const decodificarBase64 = (valor) => {
    if (typeof window !== 'undefined' && typeof window.atob === 'function') {
        return window.atob(valor);
    }
    return Buffer.from(valor, 'base64').toString('binary');
};

const binarioParaTexto = (binario) => decodeURIComponent(
    Array.from(binario, (c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`).join('')
);

export const lerAvisosDoCabecalho = (headers) => {
    const bruto = headers?.['x-despacho-avisos'] || headers?.['X-Despacho-Avisos'];
    if (!bruto) return [];

    try {
        const lista = JSON.parse(binarioParaTexto(decodificarBase64(bruto)));
        return Array.isArray(lista) ? lista : [];
    } catch (e) {
        console.error('Nao foi possivel ler os avisos do cabecalho:', e);
        return [];
    }
};
